(function() {
  'use strict';

  const STORAGE_KEY = 'eupoupo_age_verified';
  const ADULT_MENU_LABEL = 'sexual wellness';
  const ADULT_URL_HINTS = ['sexual-wellness', 'bdsm', 'preservativo', 'lingerie', 'saude-sensual', 'bem-estar-sexual'];

  function getTranslations() {
    const el = document.getElementById('age-gate-translations');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function getMenuLabel(menuEl) {
    if (!menuEl) return '';
    const ariaLabel = menuEl.getAttribute('aria-label');
    if (ariaLabel) return ariaLabel.toLowerCase().trim();
    const titledSpan = menuEl.querySelector(':scope > span[title]');
    if (titledSpan) {
      const title = titledSpan.getAttribute('title') || titledSpan.textContent;
      return title.toLowerCase().trim();
    }
    return menuEl.textContent.toLowerCase().trim();
  }

  function isAdultMenuLabel(label) {
    return label === ADULT_MENU_LABEL || label.indexOf(ADULT_MENU_LABEL) === 0;
  }

  function isInsideAdultMenu(el) {
    const topLi = el.closest('.list-menu--inline > li');
    if (topLi) {
      const topItem = topLi.querySelector(':scope > .header__menu-item, :scope > a.header__menu-item');
      if (isAdultMenuLabel(getMenuLabel(topItem))) return true;
    }
    const subLi = el.closest('.header__inline-menu li');
    if (subLi) {
      const parentTopLi = subLi.closest('.list-menu--inline > li');
      if (parentTopLi) {
        const parentItem = parentTopLi.querySelector(':scope > .header__menu-item, :scope > a.header__menu-item');
        if (isAdultMenuLabel(getMenuLabel(parentItem))) return true;
      }
    }
    return false;
  }

  function isAdultPath(path) {
    for (let i = 0; i < ADULT_URL_HINTS.length; i++) {
      if (path.indexOf(ADULT_URL_HINTS[i]) !== -1) return true;
    }
    return false;
  }

  function isAdultLink(el) {
    if (!el || !el.href) return false;
    try {
      if (isInsideAdultMenu(el)) return true;
      const path = new URL(el.href, window.location.origin).pathname.toLowerCase();
      return isAdultPath(path);
    } catch(e) {
      return false;
    }
  }

  function isVerified() {
    try {
      if (sessionStorage.getItem(STORAGE_KEY) === 'true') return true;
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.indexOf('popup-age-') === 0) {
          sessionStorage.setItem(STORAGE_KEY, 'true');
          return true;
        }
      }
    } catch(e) {}
    return false;
  }

  function setVerified() {
    try { sessionStorage.setItem(STORAGE_KEY, 'true'); } catch(e) {}
  }

  let activeDialog = null;
  let triggerElement = null;

  function createModal() {
    const t = getTranslations();

    const dialog = document.createElement('dialog');
    dialog.id = 'age-gate-dialog';
    dialog.className = 'age-gate-modal';
    dialog.setAttribute('aria-labelledby', 'age-gate-title');
    dialog.setAttribute('aria-modal', 'true');

    const title = document.createElement('h2');
    title.id = 'age-gate-title';
    title.className = 'age-gate-modal__title';
    title.textContent = t.title || 'Age Verification';

    const text = document.createElement('p');
    text.className = 'age-gate-modal__text';
    text.textContent = t.message || 'This section contains adult products. Are you over 18?';

    const actions = document.createElement('div');
    actions.className = 'age-gate-modal__actions';

    const btnNo = document.createElement('button');
    btnNo.id = 'age-gate-no';
    btnNo.className = 'age-gate-modal__button age-gate-modal__button--no';
    btnNo.type = 'button';
    btnNo.textContent = t.deny || 'No';

    const btnYes = document.createElement('button');
    btnYes.id = 'age-gate-yes';
    btnYes.className = 'age-gate-modal__button age-gate-modal__button--yes';
    btnYes.type = 'button';
    btnYes.textContent = t.confirm || 'Yes, I am 18+';

    actions.appendChild(btnNo);
    actions.appendChild(btnYes);
    dialog.appendChild(title);
    dialog.appendChild(text);
    dialog.appendChild(actions);
    document.body.appendChild(dialog);

    return dialog;
  }

  function closeDialog(callback) {
    if (!activeDialog) return;
    activeDialog.close();
    activeDialog.remove();
    activeDialog = null;
    const returnTo = triggerElement;
    triggerElement = null;
    if (typeof callback === 'function') {
      callback();
    } else if (returnTo && returnTo.focus) {
      returnTo.focus();
    }
  }

  function showAgeGate(targetHref) {
    if (activeDialog) {
      activeDialog.remove();
      activeDialog = null;
    }

    const dialog = createModal();
    activeDialog = dialog;

    dialog.querySelector('#age-gate-yes').addEventListener('click', function() {
      setVerified();
      closeDialog(function() {
        if (targetHref) {
          window.location.href = targetHref;
        } else if (triggerElement && triggerElement.focus) {
          triggerElement.focus();
        }
      });
    });

    dialog.querySelector('#age-gate-no').addEventListener('click', function() {
      closeDialog();
    });

    dialog.addEventListener('cancel', function(e) {
      e.preventDefault();
      closeDialog();
    });

    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) {
        closeDialog();
      }
    });

    dialog.showModal();
    dialog.querySelector('#age-gate-yes').focus();
  }

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;
    if (!isAdultLink(link)) return;
    if (isVerified()) return;

    e.preventDefault();
    e.stopPropagation();
    triggerElement = link;
    showAgeGate(link.href);
  }, true);

  function checkDirectAccess() {
    if (isVerified()) return;
    const path = window.location.pathname.toLowerCase();
    if (isAdultPath(path)) {
      showAgeGate(null);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkDirectAccess);
  } else {
    checkDirectAccess();
  }
})();
